import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Select } from 'ui/components';

const statusOptions = [
  { value: 'active', label: 'Aktif' },
  { value: 'completed', label: 'Selesai' },
];

const typeOptions = [
  {value: 'On Demand', label: 'On Demand'},
  {value: 'Project', label: 'Project'},
  {value: 'Routine', label: 'Routine'}
]

const initialState = {
  status: null,
  type: null
};

const Filter = ({ show, onClose, ProjectTable, setCount }) => {
  const [{ status, type }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (ProjectTable?.State?.filter) {
      let x = [];
      Object.keys(ProjectTable?.State?.filter).forEach((k) => {
        if (
          ProjectTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      status: e,
    }));
    ProjectTable.filter('status', e?.value);
    handleFilter();
  };

  const handleType = (e) => {
    setState((prevState) => ({
      ...prevState,
      type: e,
    }));
    ProjectTable.filter('type', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={statusOptions}
            value={status}
            onChange={handleStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Tipe
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={typeOptions}
            value={type}
            onChange={handleType}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={statusOptions}
              value={status}
              onChange={handleStatus}
            />
          </div>
          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tipe
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={typeOptions}
              value={type}
              onChange={handleType}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
